if (!customElements.get('almeora-variant-picker')) customElements.define('almeora-variant-picker', class extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    this.variants = JSON.parse(this.querySelector('[data-config-variants]').textContent);
    this.backend = this.querySelector('[data-config-backend]');
    this.backend.hidden = true;
    this.addEventListener('change', event => {
      if (event.target.closest('[data-config-backend]')) return;
      const index = Number(event.target.closest('[data-config-option]')?.dataset.configOption);
      const options = this.options();
      let variant = this.variants.find(v => v.options.every((value, i) => value === options[i]));
      if (!variant) variant = this.variants.find(v => v.options[index] === options[index] && v.available) || this.variants.find(v => v.options[index] === options[index]);
      if (variant) this.select(variant);
    }, {signal: this.controller.signal});
    const selected = this.backend.querySelector('input:checked') || this.backend.querySelector('select');
    const variant = this.variants.find(v => String(v.id) === selected?.value);
    if (variant) this.sync(variant);
  }
  options() {return [...this.querySelectorAll('[data-config-option]')].map(el => el.tagName === 'SELECT' ? el.value : el.querySelector('input:checked')?.value);}
  sync(variant) {
    this.querySelectorAll('[data-config-option]').forEach(el => {
      const value = variant.options[Number(el.dataset.configOption)];
      if (el.tagName === 'SELECT') el.value = value;
      else el.querySelectorAll('input').forEach(input => input.checked = input.value === value);
    });
    this.querySelector('[data-config-summary]').textContent = `${variant.title === 'Default Title' ? '' : variant.title + ' · '}${new Intl.NumberFormat(this.dataset.locale || 'fr', {style:'currency',currency:this.dataset.currency || 'EUR'}).format(variant.price / 100)}`;
  }
  select(variant) {
    this.sync(variant);
    const control = this.backend.querySelector('select') || [...this.backend.querySelectorAll('input[name="id"]')].find(input => input.value === String(variant.id));
    if (control.tagName === 'SELECT') control.value = String(variant.id); else control.checked = true;
    control.dispatchEvent(new Event('change',{bubbles:true}));
  }
  disconnectedCallback() {this.controller?.abort();this.controller=null;}
});
